module.exports = __webpack_public_path__ + "static/assets/2e13cc4e6bf302ef51a8eece44ee0b91.png";